var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('Header',{attrs:{"title":"Import/Export Products","divider":false,"options":[]}}),_c('ImportExportTabs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }